<script lang="ts" setup>
import { computed } from 'vue';

defineExpose({
  name: 'TypeLabel',
});

interface Props {
  isRequired?: boolean;
}
const props = withDefaults(defineProps<Props>(), {
  isRequired: true,
});

const label = computed(() => {
  return props.isRequired ? '必須' : '任意';
});
</script>

<template>
  <span class="TypeLabel" :class="{ 'TypeLabel--required': isRequired }">
    {{ label }}
  </span>
</template>

<style lang="scss" scoped>
@use '@spectee/assets/scss/_forward.scss' as *;

.TypeLabel {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 $service-unit;
  //width: $service-unit * 6.5;
  height: $service-unit * 3.5;
  font-size: $service-font-size-ppp;
  line-height: $service-line-height-mf;
  color: $color-white-100;
  border-radius: calc($service-border-radius / 2);

  &--required {
    background-color: $color-red-70;
  }

  &:not(&--required) {
    background-color: $color-gray-60;
  }
}
</style>
